import Cookies from 'js-cookie';

/*
	Cookie scoping notes (for team reference):

	- Cookie collisions are controlled by domain/path scope, NOT ONLY by cookie name.

	- This means multiple portals can keep the same token key (for example authToken / CustAuthToken)
	 without collisions, as long as each portal uses different scope.

	- For strict per-subdomain isolation, use host-only cookies by leaving domain
	 unset (empty ENV var). Example: bbportal.brewerybranding.com and
	  account.brewerybranding.com can both store authToken independently.

	- If domain is set to .brewerybranding.com, cookies are shared across
	  subdomains and the same name can overwrite between portals.
	- path can further isolate cookies within one host (e.g. /portal-a, /portal-b).

	- secure controls whether the browser only sends the cookie over HTTPS.
	  Set VITE_SECURE_COOKIE=TRUE in HTTPS environments (stage/prod).
	  If omitted or not TRUE, secure defaults to false for local HTTP/dev use.
*/
const cookiePath = import.meta.env.VITE_COOKIE_BASE_PATH;
const cookieDomain = import.meta.env.VITE_COOKIE_BASE_DOMAIN;
const secureCookieFlag = import.meta.env.VITE_SECURE_COOKIE;

if(!cookiePath) {
	console.warn('[portal-cookie] VITE_COOKIE_BASE_PATH is not set. Falling back to "/".');
}

if(!cookieDomain) {
	console.warn('[portal-cookie] VITE_COOKIE_BASE_DOMAIN is not set. Using host-only cookies.');
}

if(!secureCookieFlag) {
	console.warn('[portal-cookie] VITE_SECURE_COOKIE is not set. secure will default to false.');
}

const cookieAttributes = {
	path: cookiePath || '/',
	// TRUE means HTTPS-only cookie transmission.
	secure: secureCookieFlag === 'TRUE',
	expires: 365,
};

// Keep the cookie host-only when no domain is configured.
if(cookieDomain) {
	cookieAttributes.domain = cookieDomain;
}

const portalCookie = Cookies.withAttributes(cookieAttributes);


export default portalCookie;
